import {
  ExpediaBusinessIcon,
  FamilyIcon,
  ExpediaFunBusinessIcon,
  ExpediaFunIcon,
} from '@assets/icons';

const REVİEW_TYPES_EXPEDIA = {
  BUSSINESS: 'business',
  FUN: 'leisure',
  BUSSINESSFUN: 'business_and_leisure',
  FRIENDSFAMILY: 'friends_and_family',
};

export const getExpediaReviewIcon = (type: string) => {
  switch (type) {
    case REVİEW_TYPES_EXPEDIA.BUSSINESS:
      return ExpediaBusinessIcon;
    case REVİEW_TYPES_EXPEDIA.FUN:
      return ExpediaFunIcon;
    case REVİEW_TYPES_EXPEDIA.BUSSINESSFUN:
      return ExpediaFunBusinessIcon;
    case REVİEW_TYPES_EXPEDIA.FRIENDSFAMILY:
      return FamilyIcon;
    default:
      return undefined;
  }
};

export const getExpediaReviewType = (type: string) => {
  switch (type) {
    case REVİEW_TYPES_EXPEDIA.BUSSINESS:
      return 'İş';
    case REVİEW_TYPES_EXPEDIA.FUN:
      return 'Eğlence';
    case REVİEW_TYPES_EXPEDIA.BUSSINESSFUN:
      return 'İş ve Eğlence';
    case REVİEW_TYPES_EXPEDIA.FRIENDSFAMILY:
      return 'Arkadaşlar ve Aile';
    default:
      return undefined;
  }
};

export const getRating = (type: number) => {
  if (type >= 4.5) {
    return 'Mükemmel';
  } else if (type >= 4 && type < 4.5) {
    return 'Çok iyi';
  } else if (type >= 3 && type < 4) {
    return 'İyi';
  } else if (type < 3) {
    return 'Orta';
  }
};

export const getRatingAboveFour = (type: number) => type >= 4;
